"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DragAndDropEvent = void 0;

var _Event = _interopRequireDefault(require("../events/Event.js"));

var _EventType = _interopRequireDefault(require("../events/EventType.js"));

var _FormatType = _interopRequireDefault(require("../format/FormatType.js"));

var _Interaction = _interopRequireDefault(require("./Interaction.js"));

var _functions = require("../functions.js");

var _proj = require("../proj.js");

var _events = require("../events.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @module ol/interaction/DragAndDrop
 */
// FIXME should handle all geo-referenced data, not just vector data
var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

/**
 * @typedef {Object} Options
 * @property {Array<typeof import("../format/Feature.js").default|import("../format/Feature.js").default>} [formatConstructors] Format constructors
 * (and/or formats pre-constructed with options).
 * @property {import("../source/Vector.js").default} [source] Optional vector source where features will be added.  If a source is provided
 * all existing features will be removed and new features will be added when
 * they are dropped on the target.  If you want to add features to a vector
 * source without removing the existing features (append only), instead of
 * providing the source option listen for the "addfeatures" event.
 * @property {import("../proj.js").ProjectionLike} [projection] Target projection. By default, the map's view's projection is used.
 * @property {HTMLElement} [target] The element that is used as the drop target, default is the viewport element.
 */

/**
 * @enum {string}
 */
var DragAndDropEventType = {
  /**
   * Triggered when features are added
   * @event DragAndDropEvent#addfeatures
   * @api
   */
  ADD_FEATURES: 'addfeatures'
};
/**
 * @classdesc
 * Events emitted by {@link module:ol/interaction/DragAndDrop~DragAndDrop} instances are instances
 * of this type.
 */

var DragAndDropEvent =
/** @class */
function (_super) {
  __extends(DragAndDropEvent, _super);
  /**
   * @param {DragAndDropEventType} type Type.
   * @param {File} file File.
   * @param {Array<import("../Feature.js").default>} [opt_features] Features.
   * @param {import("../proj/Projection.js").default} [opt_projection] Projection.
   */


  function DragAndDropEvent(type, file, opt_features, opt_projection) {
    var _this = _super.call(this, type) || this;
    /**
     * The features parsed from dropped data.
     * @type {Array<import("../Feature.js").FeatureLike>|undefined}
     * @api
     */


    _this.features = opt_features;
    /**
     * The dropped file.
     * @type {File}
     * @api
     */

    _this.file = file;
    /**
     * The feature projection.
     * @type {import("../proj/Projection.js").default|undefined}
     * @api
     */

    _this.projection = opt_projection;
    return _this;
  }

  return DragAndDropEvent;
}(_Event["default"]);

exports.DragAndDropEvent = DragAndDropEvent;

/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'addfeatures', DragAndDropEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'addfeatures', Return>} DragAndDropOnSignature
 */

/**
 * @classdesc
 * Handles input of vector data by drag and drop.
 *
 * Note that the DragAndDrop interaction uses the TextDecoder() constructor if the supplied
 * combination of formats read both text string and ArrayBuffer sources. Older browsers such
 * as IE which do not support this will need a TextDecoder polyfill to be loaded before use.
 *
 * @api
 *
 * @fires DragAndDropEvent
 */
var DragAndDrop =
/** @class */
function (_super) {
  __extends(DragAndDrop, _super);
  /**
   * @param {Options} [opt_options] Options.
   */


  function DragAndDrop(opt_options) {
    var _this = this;

    var options = opt_options ? opt_options : {};
    _this = _super.call(this, {
      handleEvent: _functions.TRUE
    }) || this;
    /***
     * @type {DragAndDropOnSignature<import("../events").EventsKey>}
     */

    _this.on;
    /***
     * @type {DragAndDropOnSignature<import("../events").EventsKey>}
     */

    _this.once;
    /***
     * @type {DragAndDropOnSignature<void>}
     */

    _this.un;
    /**
     * @private
     * @type {boolean}
     */

    _this.readAsBuffer_ = false;
    /**
     * @private
     * @type {Array<import("../format/Feature.js").default>}
     */

    _this.formats_ = [];
    var formatConstructors = options.formatConstructors ? options.formatConstructors : [];

    for (var i = 0, ii = formatConstructors.length; i < ii; ++i) {
      var format = formatConstructors[i];

      if (typeof format === 'function') {
        format = new format();
      }

      _this.formats_.push(format);

      _this.readAsBuffer_ = _this.readAsBuffer_ || format.getType() === _FormatType["default"].ARRAY_BUFFER;
    }
    /**
     * @private
     * @type {import("../proj/Projection.js").default}
     */


    _this.projection_ = options.projection ? (0, _proj.get)(options.projection) : null;
    /**
     * @private
     * @type {?Array<import("../events.js").EventsKey>}
     */

    _this.dropListenKeys_ = null;
    /**
     * @private
     * @type {import("../source/Vector.js").default}
     */

    _this.source_ = options.source || null;
    /**
     * @private
     * @type {HTMLElement|null}
     */

    _this.target = options.target ? options.target : null;
    return _this;
  }
  /**
   * @param {File} file File.
   * @param {Event} event Load event.
   * @private
   */


  DragAndDrop.prototype.handleResult_ = function (file, event) {
    var result = event.target.result;
    var map = this.getMap();
    var projection = this.projection_;

    if (!projection) {
      var view = map.getView();
      projection = view.getProjection();
    }

    var text;
    var formats = this.formats_;

    for (var i = 0, ii = formats.length; i < ii; ++i) {
      var format = formats[i];
      var input = result;

      if (this.readAsBuffer_ && format.getType() !== _FormatType["default"].ARRAY_BUFFER) {
        if (text === undefined) {
          text = new TextDecoder().decode(result);
        }

        input = text;
      }

      var features = this.tryReadFeatures_(format, input, {
        featureProjection: projection
      });

      if (features && features.length > 0) {
        if (this.source_) {
          this.source_.clear();
          this.source_.addFeatures(features);
        }

        this.dispatchEvent(new DragAndDropEvent(DragAndDropEventType.ADD_FEATURES, file, features, projection));
        break;
      }
    }
  };
  /**
   * @private
   */


  DragAndDrop.prototype.registerListeners_ = function () {
    var map = this.getMap();

    if (map) {
      var dropArea = this.target ? this.target : map.getViewport();
      this.dropListenKeys_ = [(0, _events.listen)(dropArea, _EventType["default"].DROP, this.handleDrop, this), (0, _events.listen)(dropArea, _EventType["default"].DRAGENTER, this.handleStop, this), (0, _events.listen)(dropArea, _EventType["default"].DRAGOVER, this.handleStop, this), (0, _events.listen)(dropArea, _EventType["default"].DROP, this.handleStop, this)];
    }
  };
  /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   */


  DragAndDrop.prototype.setActive = function (active) {
    if (!this.getActive() && active) {
      this.registerListeners_();
    }

    if (this.getActive() && !active) {
      this.unregisterListeners_();
    }

    _super.prototype.setActive.call(this, active);
  };
  /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../PluggableMap.js").default} map Map.
   */


  DragAndDrop.prototype.setMap = function (map) {
    this.unregisterListeners_();

    _super.prototype.setMap.call(this, map);

    if (this.getActive()) {
      this.registerListeners_();
    }
  };
  /**
   * @param {import("../format/Feature.js").default} format Format.
   * @param {string} text Text.
   * @param {import("../format/Feature.js").ReadOptions} options Read options.
   * @private
   * @return {Array<import("../Feature.js").default>} Features.
   */


  DragAndDrop.prototype.tryReadFeatures_ = function (format, text, options) {
    try {
      return (
        /** @type {Array<import("../Feature.js").default>} */
        format.readFeatures(text, options)
      );
    } catch (e) {
      return null;
    }
  };
  /**
   * @private
   */


  DragAndDrop.prototype.unregisterListeners_ = function () {
    if (this.dropListenKeys_) {
      this.dropListenKeys_.forEach(_events.unlistenByKey);
      this.dropListenKeys_ = null;
    }
  };
  /**
   * @param {DragEvent} event Event.
   */


  DragAndDrop.prototype.handleDrop = function (event) {
    var files = event.dataTransfer.files;

    for (var i = 0, ii = files.length; i < ii; ++i) {
      var file = files.item(i);
      var reader = new FileReader();
      reader.addEventListener(_EventType["default"].LOAD, this.handleResult_.bind(this, file));

      if (this.readAsBuffer_) {
        reader.readAsArrayBuffer(file);
      } else {
        reader.readAsText(file);
      }
    }
  };
  /**
   * @param {DragEvent} event Event.
   */


  DragAndDrop.prototype.handleStop = function (event) {
    event.stopPropagation();
    event.preventDefault();
    event.dataTransfer.dropEffect = 'copy';
  };

  return DragAndDrop;
}(_Interaction["default"]);

var _default = DragAndDrop;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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